const DEFAULT_IMAGES = {
    audio: "/assets/images/defaults/no-data.svg",
    cover: "/assets/images/defaults/no-data.svg",
    user: "/assets/images/defaults/user.svg",
    album: "/assets/images/defaults/no-data.svg",
    default: "/assets/images/defaults/no-data.svg",
};

export const getFullUrl = (url, section = "default") => {
    const fallback = DEFAULT_IMAGES[section] || DEFAULT_IMAGES.default;

    if (!url || typeof url !== "string") return fallback;

    let cleanedUrl = url.trim();

    if (!cleanedUrl) return fallback;

    // FIX: remove duplicate malformed protocol like "https://https//"
    cleanedUrl = cleanedUrl.replace(/^https?:\/\/https?:?\/?/i, "https://");

    // already valid
    if (/^https?:\/\//i.test(cleanedUrl)) {
        return cleanedUrl;
    }

    // handle //cdn.com
    if (/^\/\//.test(cleanedUrl)) {
        return `https:${cleanedUrl}`;
    }

    // looks like domain
    if (/^[\w.-]+\.[a-z]{2,}/i.test(cleanedUrl)) {
        return `https://${cleanedUrl}`;
    }

    return fallback;
};